@if (workflow) {
  <div class="ml-4 flex h-full items-center whitespace-nowrap">
    @if (isAdmin || userHasChecklistAdminPermission) {
      <ng-select
        placeholder="Assign To"
        [clearable]="true"
        [formControl]="assignToFormControl"
        [className]="'w-36'"
        (change)="changeAssign()"
      >
        <ng-container *ngVar="externalUserWithPermissionsList$ | async as usersList">
          @for (user of usersList; track user) {
            <ng-option [value]="user.sub">
              <aux-first-name-show
                [text]="
                  (user.given_name + ' ' + user.family_name).length > 30
                    ? (user.given_name + ' ' + user.family_name).substring(0, 30)
                    : user.given_name + ' ' + user.family_name
                "
                [showHyphenIfEmpty]="true"
              />
            </ng-option>
          }
        </ng-container>
      </ng-select>
    } @else {
      <div class="flex gap-2 font-bold">
        Assigned To:
        <aux-first-name-show
          [className]="'font-bold max-w-[126px]'"
          [text]="user ? user : zeroHyphen"
          [showHyphenIfEmpty]="true"
        />
      </div>
    }
  </div>
}
